import i18n from '../../language/index'
import linkData from '@/base/linkData'
let link = {
  ...linkData,
  linkType: 'none'
}
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  isSystem: 'true',
  pc_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  mb_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  pc_widgets_infor: {
    shareType: ['weixin', 'qq', 'weibo'],
    enShareType: ['twitter','wechat','facebook','linkedin'],
    share: 'open', // open closed
    shareDisplayStyle: 'default', // default tile
  },
  mb_widgets_infor: {
  },
  listArr: {
    moduleStyle: 0,
    arrowRadio: 'block',  // block none
    shareRadio: 'open', // open closed
    displayContactRadio: 'block',
    contactRadio: 'email', // phone wechat email
    phone: 18000000000,
    email: '',
    tab_title_one: 'Product Details',
    qrCodeImg: 'https://preapiconsole.71360.com/file/read/www/M00/01/5F/wKgBbF4pCUSAbiL2AAAdHOc6uzk848.png',
    paraList: [{
      title: i18n.t('widgets_basic_product_detail_style_2771'),
      id: 'brand',
      show: true,
      link:link
    }, {
      title: i18n.t('widgets_basic_product_detail_style_2772'),
      id: 'model',
      show: true,
      link:link
    }, {
      title: i18n.t('widgets_basic_product_detail_style_2773'),
      id: 'minimum',
      show: true,
      link:link
    }, {
      title: i18n.t('components_basic_addproduct_sales_2141'),
      id: 'standard',
      show: true,
      link:link
    }, {
      title: i18n.t('widgets_basic_product_detail_style_2774'),
      id: 'unit',
      show: true,
      link:link
    }, {
      title: i18n.t('widgets_basic_product_detail_style_2775'),
      id: 'pack',
      show: true,
      link:link
      }],
    scale_type: 'block'
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_product_detail/style.js